/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Horse,
} from '../models/index';
import {
    HorseFromJSON,
    HorseToJSON,
} from '../models/index';

export interface ApiHorseRegisterIdGetRequest {
    registerId: string;
}

/**
 * 
 */
export class HorseApi extends runtime.BaseAPI {

    /**
     */
    async apiHorseRegisterIdGetRaw(requestParameters: ApiHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Horse>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling apiHorseRegisterIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/{RegisterId}`.replace(`{${"RegisterId"}}`, encodeURIComponent(String(requestParameters['registerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HorseFromJSON(jsonValue));
    }

    /**
     */
    async apiHorseRegisterIdGet(requestParameters: ApiHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Horse> {
        const response = await this.apiHorseRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
